function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.5 60C117.5 91.4802 91.9802 117 60.5 117C29.0198 117 3.5 91.4802 3.5 60C3.5 28.5198 29.0198 3 60.5 3C91.9802 3 117.5 28.5198 117.5 60Z",
  stroke: "#00B056",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.957 53.5923C61.957 54.8407 61.6756 55.8034 61.1128 56.4805C60.5542 57.1576 59.765 57.4961 58.7451 57.4961C57.7168 57.4961 56.9212 57.1554 56.3584 56.4741C55.7956 55.7928 55.5142 54.8322 55.5142 53.5923V51.9038C55.5142 50.6554 55.7935 49.6927 56.3521 49.0156C56.9149 48.3385 57.7083 48 58.7324 48C59.7565 48 60.55 48.3407 61.1128 49.022C61.6756 49.7033 61.957 50.666 61.957 51.9102V53.5923ZM59.8179 51.6309C59.8179 50.9665 59.7311 50.4714 59.5576 50.1455C59.3841 49.8154 59.109 49.6504 58.7324 49.6504C58.3643 49.6504 58.0955 49.8027 57.9263 50.1074C57.7612 50.4121 57.6724 50.8734 57.6597 51.4912V53.8525C57.6597 54.5423 57.7464 55.048 57.9199 55.3696C58.0934 55.687 58.3685 55.8457 58.7451 55.8457C59.109 55.8457 59.3778 55.6912 59.5513 55.3823C59.7248 55.0692 59.8136 54.5804 59.8179 53.916V51.6309Z",
  fill: "#00B056"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.7529 57.3691H50.6074V50.5391L48.5 51.1548V49.5298L52.5562 48.127H52.7529V57.3691Z",
  fill: "#00B056"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M68.7109 57.3691H70.9263V48.127H68.7109V51.7959H65.4292V48.127H63.2012V57.3691H65.4292V53.5098H68.7109V57.3691Z",
  fill: "#00B056"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.5 52L60.5 90L30.5 52L45.5 30H74.5L90.5 52ZM71.9539 35L84.2274 51.8761L60.5 81.9309L36.6993 51.7833L48.1425 35H71.9539Z",
  fill: "#00B056"
});

function SvgIgl10H(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgl10H);
export default __webpack_public_path__ + "static/media/IGL10H.1d3bd36e.svg";
export { ForwardRef as ReactComponent };